import {createRequest, makeRequest, prepareRequest, createDeleteRequest} from "../utils/apiUtil";

export function getAll(page, perPage) {
    let params = {per_page: perPage, page: page, sort: '-created_at'};
    return makeRequest(createRequest('notification'), prepareRequest({}, [], params));
}

export function remove(notificationId) {
    return makeRequest(createDeleteRequest('notification/' + notificationId));
}